import React, { useMemo } from 'react';
import cs from './index.module.scss';

interface Props {
  curValue: string;
  chooseEmail: (email: string) => void;
}
const emailList = [
  '@gmail.com',
  '@hotmail.com',
  '@outlook.com',
  '@yahoo.com',
  '@163.com',
  '@126.com',
  '@qq.com',
  '@139.com',
  '@sina.com',
  '@sohu.com',
  '@icloud.com',
  '@naver.com',
  '@drmail.in',
  '@aol.com',
  '@yandex.com',
  '@zoho.com',
  '@gmx.com',
  '@mail.com',
  '@protonmail.com',
  '@tutanota.com',
  '@mail.ru',
  '@live.com',
  '@rocketmail.com',
  '@ymail.com',
  '@mail.ru',
  '@rambler.ru',
  '@bk.ru',
  '@inbox.ru',
  '@bigmir.net',
  '@ukr.net',
  '@abv.bg',
  '@mail.bg',
  '@libero.it',
  '@tiscali.it',
  '@tin.it',
];

const EmailSelectList: React.FC<Props> = ({ chooseEmail, curValue }) => {
  const { filterEmailName, filterEmailList } = useMemo(() => {
    if (!curValue) {
      return { filterEmailName: '', filterEmailList: [] as string[] };
    }

    const parts = curValue.split('@');
    const inputName = parts[0] || '';
    const inputDomain = parts[1] || '';

    const filteredList = emailList.filter(domain => domain.includes(inputDomain));

    return { filterEmailName: inputName, filterEmailList: filteredList };
  }, [curValue]);

  if (filterEmailList.length === 0) {
    return null;
  }

  return (
    <div className={cs.container}>
      <div className={cs.emailSelectList}>
        <div className={cs.scrollContainer}>
          {filterEmailList.map((item, index) => (
            <div key={index} className={cs.emailItem} onClick={() => chooseEmail(`${filterEmailName}${item}`)}>
              <span className={cs.emailName}>{filterEmailName}</span>
              <span className={cs.emailType}>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmailSelectList;
